
<!--start section header-->
<header>
    <!--start section slick carousel-->
<section class="slick">
    <div>
        <div data-slick='{"slidesToShow": 1, "slidesToScroll": 1}' class="slick-carousel bg-dark text-white">
                
                    
            <div class="slick-img">
                <div class="img3">
                    <div class="rgb"></div>
                </div>
              <div class="slick-caption3">
                  <div>
                    <h5>Our researchers are focused on</h5>
                    <h2>Developing Innovative
                      <br>
                        New Therapies...</h2>
                    <p>Our mission is to build a healthier tomorrow for patients
                        <br>
                       with progressive non-viral liver diseases</p>
                     <button class="btn px-4 mt-3">Discover Now </button>
                  </div>
              </div> 
               
            </div>
            <div class="slick-img ">
                <div class="img2">
                    <div class="rgb"></div>
                </div>
              <div class="slick-caption2">
                  <div>
                    <h5>We will Help You</h5>
                    <h2>To Live Healthy Life</h2>
                    <p>Our mission is to build a healthier tomorrow for patients
                        <br>
                       with progressive non-viral liver diseases</p>
                     <button class="btn px-4 mt-3">Discover Now </button>
                  </div>
              </div> 
               
            </div>
            <div class="slick-img ">
                <div class="img1">
                    <div class="rgb"></div>
                </div>
              <div class="slick-caption1">
                  <div>
                    <h5>We are dedicated to the</h5>
                    <h2>Discovery, Development &
                      <br>
                       Commercialization</h2>
                    <p>Our mission is to build a healthier tomorrow for patients
                        <br>
                        with progressive non-viral liver diseases</p>
                     <button class="btn px-4 mt-3">Discover Now </button>
                  </div>
              </div> 
               
            </div>
         
            
        </div>
    </div>
  </section>
  
      
<!--end section slick carousel-->
    
</header>

<!--start section header-->

<!--start section Our Site-->


<section class="container py-5">

    <div class="text-center section-header">
      <h2 class="pt-5 pb-2">Welcome to Our Site!</h2>
      <p class="pb-3 text-muted">We are a biopharmaceutical company focused on the discovery, development and commercialization of <br>
         innovative therapies intended to improve outcomes in patients sufferings
      </p>
    </div>
    <div class="row">
  
      <div class="col-lg-4 col-md-6">
        <div class="text-center py-5 border mb-3">
          <i class="far fa-user fa-3x pb-3"></i>
          <h4 class="pb-3">Pharma Team</h4>
          <p class="pb-5 text-muted">Company was founded by scientists <br> dedicated to create new therapeutics.</p>
          <button class="btn btn-outline-danger  py-2" >Our Team</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="text-center py-5 border mb-3">
          <i class="far fa-lightbulb fa-3x pb-3"></i>
          <h4 class="pb-3">Pharma Focus</h4>
          <p class="pb-5 text-muted">We Interrogate the inner life of GPCR <br> signaling to develop newest.</p>
          <button class="btn btn-outline-danger py-2 bg" >Discover Now</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 center-content">
        <div class="text-center py-5 border mb-3">
          <i class="far fa-paper-plane fa-3x pb-3"></i>
          <h4 class="pb-3">Pharma Pipeline</h4>
          <p class="pb-5 text-muted">Consetetur sadipscing elitr sediam <br> nonumy eirmod tempor invidunt labore.</p>
          <button class="btn btn-outline-danger  py-2" >Check it</button>
        </div>
      </div>
  
    </div>
  
  </section>
  
  <!--end section Our Site-->

  <!--start section See Our Products-->
  <section class="py-5 product container-fluid">
    <div class="row">
      <div class="col-lg-12">

        <div class="parallax-window" data-parallax="scroll">
            <div class="container py-5">
              <div class="row">

                  <div class="col-md-6  product-caption">
                     <div class="pt-3">
                       <h2 class="text-white pb-4 product-h2">
                         See Our Products
                       </h2>
                       <p class="prodcut-p1 font-weight-bold pb-2">
                         We have several product candidates in development that we believe have been significantly de-risked.
                       </p>
                       <p class="prodcut-p2 pb-4">
                         been significantly de-risked. At vero eos et accusam justo duo dolores
                         etea rebuitet clita kasd gubergren nosea takimata sanctus est lorem 
                         ipsum dolor consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt
                         ut labore magna aliquyam sedam voluptua at vero eos et accusam et justo duo dolores.
                       </p>
                       <button class="btn btn-outline-danger py-2" >See All projects</button>

                      </div>
                  </div>
                  <div class="col-md-6 pt-3 product-img">
                    <img src="assets/images/b.jpg" class="img-fluid" alt="Drugs">
                  </div>
                  <div class="col-md pt-4">
                    <img src="assets/images/e.jpg" class="img-fluid pop-img" alt="rivet">
                  </div>
                  <div class="col-md pt-4">
                    <img src="assets/images/m.jpg" class="img-fluid pop-img" alt="rivet">
                  </div>
                  <div class="col-md pt-4">
                    <img src="assets/images/h.jpg" class="img-fluid pop-img" alt="rivet">
                  </div>
                  <div class="col-md pt-4">
                    <img src="assets/images/i.jpg" class="img-fluid pop-img" alt="rivet">
                  </div>
                  <div class="col-md pt-4">
                    <img src="assets/images/w.jpg" class="img-fluid pop-img" alt="rivet">
                  </div>
              </div>
            </div>

        </div>


      </div>

    </div>
    

  </section>
  <section class="full-width justify-content-center align-items-center">
    <div class="mins-width d-flex justify-content-between align-items-center ">
      <i id="close" class="fas fa-1x fa-window-close"></i>
      <i id="prev" class="fas fa-1x fa-chevron-left ml-3"></i>
      <i id="next" class="fas fa-1x fa-chevron-right mr-3"></i>
    </div>
  </section>

  <!--end section See Our Products-->

  <!--start section why choose-->

   <section class="container py-5">
     <div class="row">
        
       <div class="col-lg-4 col-md-12 pb-4">
         <div class="choose-content content-width">
           <h3 class="font-weight-bold pb-4">
            Why Choose Us?
           </h3>
           <button class="btn btn-outline-danger py-2" >About Us</button>
         </div>
       </div>
       <div class="col-lg-4 col-md-6 pb-3">
        <div class="media choose-content pb-4">
          <i class="far fa-gem mr-3"></i>
          <div class="media-body">
            <h5 class="mt-0">Newest Technologies</h5>
            <p>Consetetur sadipscing elitr diam nonumy eirmod tempor invidunt.</p>
          </div>
        </div>
        <div class="media choose-content">
          <i class="fas fa-cloud mr-3"></i>
          <div class="media-body">
            <h5 class="mt-0">Taking Care of Nature</h5>
            <p>Ut labore et dolore magna aliquyam erat sed diam voluptua.</p>
          </div>
        </div>
      </div>


      <div class="col-lg-4 col-md-6 ">
        <div class="media choose-content pb-4">
          <i class="fas fa-tag mr-3"></i>
          <div class="media-body">
            <h5 class="mt-0">Fair Prices</h5>
            <p>At vero eos et accusam ejusto duo dolores et ea rebum clita gubergren.</p>
          </div>
        </div>
        <div class="media choose-content">
          <i class="fas fa-cloud mr-3"></i>
          <div class="media-body">
            <h5 class="mt-0">High Customer Satisfaction</h5>
            <p>Nosea takimata sanctus est lorem ipsum dolor sit amet.</p>
          </div>
        </div>
      </div>
       

           






     </div>
   </section>


  <!--end section why choose-->
  

  <!--start section progress-->
    
    <section class="progress py-4">
      <div class="container py-4">
        <div class="row">

          <div class="col-lg col-md-6">
            <div class="one circle">
              <strong></strong>
              <p class="pt-4 p1">Years Experience</p>
            </div>
          </div>
          <div class="col-lg col-md-6">
            <div class="second circle">
              <strong></strong>
              <p class="pt-4 p2">Medicament Invented</p>
            </div>
          </div>
          <div class="col-lg col-md-6">
            <div class="thrid circle">
              <strong></strong>
              <p class="pt-4 p3">Awards Winned</p>
            </div>
          </div>
          <div class="col-lg col-md-6">
            <div class="four circle">
              <strong></strong>
              <p class="pt-4 p4">Happy Clients</p>
            </div>
          </div>
          <div class="col-lg col-md-6">
            <div class="five circle">
              <strong></strong>
              <p class="pt-4 p5">Pharmacies Partners</p>
            </div>
          </div>








        </div>
      </div>
    </section>
   
  <!--end section progress-->


  <!--start section pipeline-->

  <section class="pipeline">
    <div class="pipe-cover">

      <div class="container py-5">
        <div class="row pt-5">


          <div class="col-lg-6 offset-lg-6 pt-5">
            <div class="pipe-content pb-3">
              <h2 class="pb-4 text-white">Development pipeline</h2>
              <p class="pipe-p1 pb-2">Balanced mix of new substance developments and life cycle management opportunities.</p>
              <p class="pipe-p2">We focus on core competencies and its many years of experience.
                 We thus hold a leading position in many therapeutic fields: for instance
                  in the treatment of hemophilia and multiple sclerosis, in contrast media and oral
                 contraception. We are also striving for such a leading position in oncology.
              </p>
            </div>

            <div class="row">

              <div class="col-md-4 col-sm-6 col-xs-6 mb-3">
                <div class="pipe-caption p-4">
                  <p>01</p>
                  <h5>Research & preclinical</h5>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-6 mb-3">
                <div class="pipe-caption p-4">
                  <p>02</p>
                  <h5>Starting Phase</h5>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-6  mb-3">
                <div class="pipe-caption p-4">
                  <p>03</p>
                  <h5>medium phase</h5>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-6 mb-3">
                <div class="pipe-caption p-4 marg">
                  <p>04</p>
                  <h5>Finishing Phase</h5>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-6 mb-3">
                <div class="pipe-caption p-4 marg">
                  <p>05</p>
                  <h5>After Drug Approval</h5>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-6 mb-3">
                <div class="pipe-caption p-4 marg">
                  <p>06</p>
                  <h5>Drugs Production</h5>
                </div>
              </div>

            </div>

          </div>
          



        </div>
      </div>

    </div>
  </section>

   <!--end section pipeline-->

   <!--start section Recent content-->

   <section class="container py-5 Recent-content">
     <div class="pt-5 d-flex justify-content-center">
       <h3 class="py-4 recent-h3">
        Our Recent Blogs
       </h3>
     </div>
     <div class="row">


      <div class="col-lg-6">
        <div>
          <div class="accordion" id="accordionExample">
            <div class="card mb-4">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                       <div class="d-flex justify-content-start">
                         <div class="mr-3 card-header1">
                           <h2>09</h2>
                           <p>10/17</p>
                         </div>
                         <div class="card-header2">
                           <h4>At vero eos et accusam justo duo</h4>
                           <p>
                             <i class="fas fa-user"></i>
                             by Sam C.Hood
                           </p>
                         </div>
                         <div class="posit card-header3">
                          <i class="fas fa-comment"></i>
                          87
                         </div>
                       </div>
                  </button>
                </h2>
              </div>
          
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                  Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                   richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.
                   Food truck quinoa nesciunt laborum eiusmo.
                </div>
              </div>
            </div>
            <div class="card mb-4">
              <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                  <button class="btn btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <div class="d-flex justify-content-start">
                      <div class="mr-3 card-header1">
                        <h2>07</h2>
                        <p>10/17</p>
                      </div>
                      <div class="card-header2">
                        <h4>Doloreset ea rebum kasdclit</h4>
                        <p>
                          <i class="fas fa-user"></i>
                          by Sandar C.Vasques
                        </p>
                      </div>
                      <div class="posit card-header3">
                       <i class="fas fa-comment"></i>
                       75
                      </div>
                    </div>
                  </button>
                </h2>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                <div class="card-body">
                  Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                   richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.
                   Food truck quinoa nesciunt laborum eiusmo.
                </div>
              </div>
            </div>
            <div class="card mb-4">
              <div class="card-header" id="headingThree">
                <h2 class="mb-0">
                  <button class="btn btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <div class="d-flex justify-content-start">
                      <div class="mr-3 card-header1">
                        <h2>04</h2>
                        <p>10/17</p>
                      </div>
                      <div class="card-header2">
                        <h4>Gubergen no sea takimata sanctus</h4>
                        <p>
                          <i class="fas fa-user"></i>
                          by Paul K.Reynolds
                        </p>
                      </div>
                      <div class="posit card-header3">
                       <i class="fas fa-comment"></i>
                        75
                      </div>
                    </div>
                  </button>
                </h2>
              </div>
              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                <div class="card-body">
                  Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                   richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.
                   Food truck quinoa nesciunt laborum eiusmo.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="recent-caption">
          <img src="assets/images/j.jpg" class="img-fluid"/>
          <div class="recent-cover">
               <div class="cover-head">
                  <div class="pt-3">
                    <h4>04</h4>
                    <p>10/17</p>
                  </div>
               </div>
               
                <div class="cover-footer">
                  <h5>Lorem ipsum dolor sit amet consectetur.</h5>
                  <p>
                    <i class="fas fa-user"></i>
                    by Margarita R.Miller
                  </p>
                </div>
               <div class="cover-footer-right">
                <i class="fas fa-comment"></i>
                  75
               </div>
          </div>
        </div>
      </div>



     </div>
     

   </section>


   <!--start section Recent content-->

   <!--start section testimonials-->
   <section class="testimonials">
    <div class="parallax" data-parallax="scroll">

     <div class="container py-5">
       <div class="d-flex justify-content-center text-white test-head py-5">
         <h2>
          Client Testimonials
         </h2>
       </div>
     
        <div data-slick='{"slidesToShow": 3, "slidesToScroll": 3}' class="slider  d-flex justify-content-center">
          <div>
            <div class="card text-center" style="width: 18rem;">
              <img src="assets/images/1.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Heidi J. Cobb
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card colors-body" style="width: 18rem;">
              <img src="assets/images/3.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Felicia L. Brooks
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card" style="width: 18rem;">
              <img src="assets/images/5.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Frank C. McGee
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card" style="width: 18rem;">
              <img src="assets/images/1.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Heidi J. Cobb
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card colors-body" style="width: 18rem;">
              <img src="assets/images/3.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Felicia L. Brooks
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card" style="width: 18rem;">
              <img src="assets/images/5.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Frank C. McGee
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          
          
        </div>
      
     </div>
    
    
    </div>

   </section>
    
   <!--end section testimonials-->


   <!--start section contactForm-->
    
     <section class="pt-5 container">
      <div class="contact">
        <div class="contact-head d-flex justify-content-center pb-3">
          <h2>Contact Form</h2>
        </div>
        <div class="row pt-3 ">


          <div class="col-lg-6 contact-content mb-3">
            <div class="w-75 m-auto">
              <input type="text" class="form-control text-center" placeholder="Name" aria-label="First name">
            </div>
          </div>
          <div class="col-lg-6 contact-content mb-3">
            <div class="w-75 m-auto">
              <input type="email" class="form-control text-center" placeholder="Email Address" aria-label="Email">
            </div>
          </div>
          <div class="col-lg-6 contact-content mb-3">
            <div class="w-75 m-auto">
              <input type="number" class="form-control text-center" placeholder="Phone number" aria-label="Phone">
            </div>
          </div>
          <div class="col-lg-6 contact-content mb-3">
            <div class="w-75 m-auto">
              <input type="text" class="form-control text-center" placeholder="Your Subject" aria-label="Subject">
            </div>
          </div>
          <div class="col-lg-12 contact-content mb-3">
            <div class="w-75 m-auto">
              <textarea class="form-control text-area text-center" placeholder="Message..." id="exampleFormControlTextarea1" rows="5"></textarea>
            </div>
          </div>
          <div class="m-auto">
            <button class="btn btn-outline-danger mt-4">Send Message</button>
          </div>
  
  
         </div>
      </div>
     </section>

  <!--end section contactForm-->

  <!--start section carousel-->

  <section class="carousel">
    <div class="container-fluid"> 

      <div data-slick='{"slidesToShow": 7, "slidesToScroll": 1}' class="center">
        <div class="col">
          <div><img src="assets/images/y.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/x.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/t.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/n.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/o.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/p.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/c.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/f.png" class="img-fluid w-75" alt=""></div>
        </div>
        <div class="col">
          <div><img src="assets/images/k.png" class="img-fluid w-75" alt=""></div>
        </div>
        

      </div>

    </div>


  </section>
  

  <!--end section carousel-->


  